import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
export default function trackAppleMapsSelectNewTimesClicked({ facility }) {
    try {
        SegmentUtils.track({
            event: 'Apple Maps Select New Times Clicked',
            properties: {
                facility_id: facility?.id ?? null,
            },
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 1,
                    },
                },
            },
        });
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Segment Event Failed - trackAppleMapsSelectNewTimesClicked',
        });
    }
}
